// Когда напоминание о стартовых заданиях последний раз показывали НА ЭТОМ
// устройстве. Именно localStorage, а не сервер: напоминание — вещь локальная
// и на другом устройстве игрок его увидит по своему расписанию
export const QUESTS_REMINDER_SHOWN_AT_STORAGE_KEY = 'questsReminderShownAt';

export const QUESTS_REMINDER_INTERVAL_MS = 24 * 60 * 60 * 1000;

/**
 * Пора ли снова показывать напоминание: записи нет, она испорчена или ей
 * больше суток. Недоступный localStorage (Safari в приватном режиме) — не
 * повод молчать, показываем как при отсутствии записи
 */
export const checkIfQuestsReminderDue = (now = Date.now()) => {
  let stored = null;
  try {
    stored = window.localStorage.getItem(QUESTS_REMINDER_SHOWN_AT_STORAGE_KEY);
  } catch (e) {
    return true;
  }
  if (!stored) return true;

  const shownAt = Number(stored);
  if (!Number.isFinite(shownAt)) return true;
  // Часы устройства могли перевести назад — запись «из будущего» считаем
  // неактуальной, иначе напоминание замолчало бы до этого будущего момента
  if (shownAt > now) return true;

  return now - shownAt >= QUESTS_REMINDER_INTERVAL_MS;
};

/**
 * Отметить показ. Вызывается ТОЛЬКО когда игрок сам закрыл напоминание: если
 * он его не тронул (перезагрузил страницу, ушел с меню) или показа не было
 * вовсе (сутки не прошли), дата не обновляется — иначе ожидание
 * растягивалось бы на каждый заход в меню
 */
export const rememberQuestsReminderShown = (now = Date.now()) => {
  try {
    window.localStorage.setItem(QUESTS_REMINDER_SHOWN_AT_STORAGE_KEY, String(now));
  } catch (e) {
    // Работаем без localStorage: напоминание просто покажется и в следующий раз
  }
};

// Показывали ли напоминание хоть раз на этом устройстве. Первый показ —
// приветственный: рассказывает про задания, а не напоминает о них
export const QUESTS_REMINDER_INTRO_SHOWN_STORAGE_KEY = 'questsReminderIntroShown';

/**
 * Первый ли это показ напоминания. Недоступный localStorage — считаем показ
 * первым: приветственный текст уместнее сухого напоминания
 */
export const checkIfQuestsReminderIntroPending = () => {
  try {
    return window.localStorage.getItem(QUESTS_REMINDER_INTRO_SHOWN_STORAGE_KEY) !== '1';
  } catch (e) {
    return true;
  }
};

/**
 * Отметить, что приветственный текст уже показан. Как и дата показа,
 * ставится только когда игрок закрыл модалку — иначе приветствие можно было
 * бы «потерять», ни разу его не прочитав
 */
export const rememberQuestsReminderIntroShown = () => {
  try {
    window.localStorage.setItem(QUESTS_REMINDER_INTRO_SHOWN_STORAGE_KEY, '1');
  } catch (e) {
    // Работаем без localStorage: приветствие покажется и в следующий раз
  }
};
